import { useAuthContext } from '../contexts/AuthContext.jsx';
import IntegrationProductsV2 from '../components/integrations/tabs/products/IntegrationProductsV2.jsx';
import { Navigate } from 'react-router-dom';
import Loading from '../components/Loading.jsx';

// Primary organization ID that should have access to this page

export default function DHGSCMapping() {
  const { loading, profile } = useAuthContext();

  if (loading) {
    return <Loading />;
  }

  // Check if user's primary organization ID matches the allowed one
  if (!profile || profile.primary_organization_id !== 'a4524ca0-beb0-47d6-8a7b-7f08f0f0a7b8') {
    return <Navigate to="/home" replace />;
  }

  const integrationId = 16;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="mb-6">
          <h1 className="text-2xl font-semibold text-gray-900">GoSpotCheck Product Mapping</h1>
        </div>
        <IntegrationProductsV2 integrationId={integrationId} />
      </div>
    </div>
  );
}

